import "./Mainsection.css";
import Photo from "./Img/Photo1.jpg";
import Typed from "react-typed";



const Mainsection = () =>{


    

    return(
        <div className="main" id="main1">
             <nav>
            <div className="photo" data-aos="fade-right">
                <img src={Photo} alt=""></img>
            </div>
        </nav>

        <div className="intro" data-aos="fade-left">

            <h2 data-aos="fade-left">Hii, My name is Chetanya Pathak</h2>
            <h2 data-aos="fade-left">I am a <Typed className="text-[#7979ed]" 
            strings={["Web Developer.","Coder."]}
            typeSpeed={75} 
            backSpeed= {50}
            loop={true}
           
            /></h2>

            <div className="underintro" data-aos="fade-left">Web Designer & Developer</div>
            <p data-aos="fade-left">I am learning web development and here is my portfolio website all my skill that i
                learnt till now in this field.</p>
            <button>About me</button>
        </div>
        </div>
    )
}

export default Mainsection;